import HeroSection from './components/HeroSection';
import SharedTrustBar from '../../components/feature/SharedTrustBar';
import ProductOverview from './components/ProductOverview';
import MidCTA from '../../components/feature/MidCTA';
import SharedAIBlock from '../../components/feature/SharedAIBlock';
import SharedHowItWorks from '../../components/feature/SharedHowItWorks';
import SharedWhyChooseUs from '../../components/feature/SharedWhyChooseUs';
import UseCases from './components/UseCases';
import SharedTestimonials from '../../components/feature/SharedTestimonials';
import SharedFAQ from '../../components/feature/SharedFAQ';
import SharedFinalCTA from '../../components/feature/SharedFinalCTA';
import { homeAIItems, repairSteps, whyReasons } from '../../mocks/shared-sections';
import { homeFaqs } from '../../mocks/faqs';

export default function HomePage() {
  return (
    <main>
      {/* 1. Hero */}
      <HeroSection />
      {/* 2. Trust Bar */}
      <SharedTrustBar />
      {/* 3. Product Section */}
      <ProductOverview />
      {/* Mid-page CTA after products */}
      <MidCTA
        headline="Don't Miss Your Next Session"
        sub="Pick up a kit before your next surf — repairs take minutes, not days."
        btnLabel="Shop Repair Kits"
        urgency="Free Micro Kit with orders over $40"
        variant="teal"
      />
      {/* 4. AI Answer Block */}
      <SharedAIBlock
        title="What Surfers Ask About PHIX Doctor"
        items={homeAIItems}
      />
      {/* 5. How It Works */}
      <SharedHowItWorks
        title="How It Works"
        subtitle="From ding to done in under 15 minutes. Back in the water the same session."
        steps={repairSteps}
      />
      {/* 6. Why Choose Us */}
      <SharedWhyChooseUs
        reasons={whyReasons}
        showComparison={true}
      />
      {/* Mid-page CTA after Why Choose Us */}
      <MidCTA
        headline="Ready to Fix Your Board?"
        sub="Join 40,000+ surfers who never let a ding cancel their session."
        btnLabel="Browse All Kits"
        urgency="Free shipping on orders over $50"
        variant="orange"
      />
      {/* 7. Use Cases / Global */}
      <UseCases />
      {/* 8. Testimonials */}
      <SharedTestimonials />
      {/* Mid-page CTA after testimonials */}
      <MidCTA
        headline="Same Results. Any Board. Any Beach."
        sub="Trusted by professionals and beginners in 60+ countries."
        btnLabel="Shop Kits Now"
        urgency="4.9★ rated by 3,000+ verified buyers"
        variant="sand"
      />
      {/* 9. FAQ */}
      <SharedFAQ
        faqs={homeFaqs}
        title="Frequently Asked"
        subtitle="Voice-search and AI-optimized answers to the most common surfboard repair questions."
      />
      {/* 10. Final CTA */}
      <SharedFinalCTA
        headline="Fix Your Board in Minutes —"
        headlineAccent="Not Days."
        urgency="Don't let a ding decide whether you surf today."
        offer="Free Micro Kit with orders over $40"
      />
    </main>
  );
}
